// Utility to handle text formatting and redaction

/**
 * Returns the chemist name, redacted if VITE_HIDE_CHEMIST_NAMES is set to "1"
 * @param {string} originalName - The actual chemist name
 * @returns {string} - The name to display
 */
export const getChemistName = (originalName) => {
  const shouldHide = import.meta.env.VITE_HIDE_CHEMIST_NAMES === '1';
  return shouldHide ? '<Redacted>' : (originalName || '');
};


